import { getCityByZip } from 'shared/services/geo';
import { useRecoilValueLoadable } from 'recoil';
import { getCityByZipcodeSelector } from 'containers/deal/recoil/selectors';

export function useCityByZipcode(zipcode: string): string {
  const cityResponse = useRecoilValueLoadable(
    getCityByZipcodeSelector({ zipcode }),
  );

  return cityResponse.valueMaybe()?.city || getCityByZip(zipcode);
}
